<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title text-uppercase">Bid Wanteds to be sent to all  {{ sendAllMode === 'ECN' ? 'ECNs' : 'OPERATORS' }} </h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form  @submit.prevent="">
                <div class="form-row">
                    <!-- <div class="form-group col-md-6 required">
                        <label for="inputLast">Quantity</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            placeholder="Quantity" 
                            v-model="sellQuantity" 
                        >
                    </div> -->
                    <div class="form-group col-md-4" style="font-size: 14px;">
                        <div class="count-sec">
                            <label for="inputLast">Bid Wanteds sent to ECN : </label>
                            <span class=" ml-2">{{ sendAllResult.BidWantedExistCount }}</span>
                        </div>
                       
                    </div>
                    <div class="form-group col-md-4" style="font-size: 14px;">
                        <div class="count-sec">
                            <label for="inputLast">Bid Wanteds to be sent : </label>
                            <span class=" ml-2">{{ sendAllResult.BidWantedSendingCount }}</span>
                        </div>
                    </div>
                    <div class="form-group col-md-4" style="font-size: 14px;">
                        <div class="count-sec">
                            <label for="inputLast">Existing offer matching BW : </label>
                            <span class=" ml-2">{{ sendAllResult.OfferExistCount }}</span>
                        </div>
                    </div>

                    <div v-if="sendAllMode == 'ECN'"  class="form-group col-md-4 required">
                        <label for="inputLast">Valid Until Time</label>
                        <ValidTime v-model="validTime"  v-bind:defaultTime="defaultValidUntilTime" />
                    </div>
                    <div v-if="sendAllMode == 'ECN'"  class="form-group col-md-4 required">
                        <label for="inputLast">Firm Until Time</label>
                        <ValidTime v-model="firmUntilTime" v-bind:defaultTime="defaultFirmUntilTime"/>
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Settlement Date</label>
                        <DatePicker :disabledDates="disabledDatesSettlement"  v-model="settlementDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></DatePicker>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputLast">Spread</label>
                        <input type="text" class="form-control" v-model="spread"/>
                    </div>
                    
                </div> 
                <div class="form-row">
                    
                </div>   
            </form>   
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button v-if="sendAllMode == 'ECN'" :disabled="!settlementDate || !firmUntilTime || !validTime "  @click="sendAllToEcn()" type="button" class="btn btn-success" >SEND TO ECN</button>
                <button v-if="sendAllMode == 'OPERATOR'" :disabled="!settlementDate"  @click="sendAllToOperator()" type="button" class="btn btn-success" >SEND TO OPERATOR</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
// import HoursPicker from "@/components/common/HoursPicker"
import ValidTime from "@/components/common/ValidTime"
import DatePicker from 'vuejs-datepicker';
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'createbidwanted',
    props: ['sendAllPayload','sendAllResult','sendAllMode'],
    components :{
        // HoursPicker,
        DatePicker,
        ValidTime
    },
    data() {
        return {
            validTime: "",
            sellQuantity : "",
            settlementDate: "",
            disabledDatesSettlement: {
                to : this.getYestedayDate()
            },
            firmUntilTime:"",
            userSettings : null,
            defaultValidUntilTime : "",
            defaultFirmUntilTime : "",
            spread : "",
            isOperatorPage : window.location.pathname.includes("/bidaccumulator/operator"),
            loading : false,
            cusipName : this.holding ? this.holding[0].cusipVal : "",
            cusipDes : this.holding ? this.holding[0].cusipDescription : "",
            deletedBidWantedIds : []
        }

    },
    methods:{
        
        sendAllToOperator(){
            var message = `Are you sure you want to send all bid wanted to operator?`;
            this.$confirm(message,"","question",{confirmButtonText:"SEND TO OPERATOR",cancelButtonText : "NO"}).then(() => {
                this.loading = true;
                const auth = {
                        headers: { 'org-token' : authService.getOrgToken() }
                    };
                    var postData = {};
                        postData = { ...postData, ...this.sendAllPayload };
                        postData.showCountOnly = false;
                        postData.settlementDate = this.moment(this.settlementDate).format("MM/DD/YYYY")
                        postData.spread = this.spread

                    this.$http
                    .post(
                    config.baseUrlAutoBidder +
                        "/bidwanted/sendAllToOperator",postData,
                        auth
                    )
                    .then(() => {
                        this.loading = false;              
                        this.$alert("Successfully sent to operator","","success");
                        this.$emit('close'); 
                    }).catch(() => this.loading = false);
                })
            },

        sendAllToEcn(){
            var beginningTime = this.moment(this.moment.utc(this.validTime).local().format("h:mma"), 'h:mma');
            var endTime = this.moment(this.moment.utc(this.firmUntilTime).local().format("h:mma"), 'h:mma');
            console.log(beginningTime,endTime)
            if(beginningTime.isAfter(endTime) || beginningTime.isSame(endTime)){
                this.$alert("Firm Until Time should be always higher than valid until time","","error");
                return ;
            }

            var message = `Are you sure you want to send all bid wanted to ECN?`;
            this.$confirm(message,"","question",{confirmButtonText:"SEND TO ECN",cancelButtonText : "NO"}).then(() => {
                this.loading = true;
                const auth = {
                        headers: { 'org-token' : authService.getOrgToken() }
                    };
                    var postData = {};
                        postData = { ...postData, ...this.sendAllPayload };
                        postData.expireMinutes = this.validTime;
                        postData.showCountOnly = false;
                        postData.settlementDate = this.moment(this.settlementDate).format("MM/DD/YYYY")
                        postData.firmUntilMinutes = this.firmUntilTime;
                        postData.spread = this.spread

                    this.$http
                    .post(
                    config.baseUrlAutoBidder +
                        "/bidwanted/sendall-to-ecn",postData,
                        auth
                    )
                    .then(() => {
                        this.loading = false;              
                        this.$alert("Successfully sent to ecn","","success");
                        this.$emit('close'); 
                    }).catch(() => this.loading = false);
                })
            },
        getOrganizationSetting(){
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.settlementDate = response.data.settlementDate;
              })
        },
        checkValid(){
            let isValid = true;
            let cusipType = this.holding[0].offeringTypeId === 1 ? "Munis" : "Corporates";
            this.holding.forEach((holding) => {
                if(!holding.sellQuantity){
                    isValid = false;
                    this.$alert("Fill all holdings sell quantity","","error");
                    return;
                 }
                if((holding.quantity - holding.filledQuantity ) < holding.sellQuantity){
                    isValid = false;
                    this.$alert("Quantity entered is greater than available quantity.","","error");
                    return;
                 }
                if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
                    isValid = false;
                    this.$alert("Holding quantity is not multiples of 5","","error");
                    return ;
                }
                if(!this.validTime){
                    isValid = false;
                    this.$alert("Valid time is required","","error");
                    return ;
                }
                if(!this.firmUntilTime){
                    isValid = false;
                    this.$alert("Firm Until is required","","error");
                    return ;
                }
            });
            return isValid
        },
        sendToEcn(){
            if(this.checkValid()){
                var beginningTime = this.moment(this.moment.utc(this.validTime).local().format("h:mma"), 'h:mma');
                var endTime = this.moment(this.moment.utc(this.firmUntilTime).local().format("h:mma"), 'h:mma');
                console.log(beginningTime,endTime)
                if(beginningTime.isAfter(endTime) || beginningTime.isSame(endTime)){
                    this.$alert("Firm Until Time should be always higher than valid until time","","error");
                    return ;
                }
                var message = `Are you sure you want to send this bid wanted to ECN?`;
                this.$confirm(message,"","question",{confirmButtonText:"SEND TO ECN",cancelButtonText : "NO"}).then(() => {
                        this.loading = true;
                        const auth = {
                            headers: { 'org-token' : authService.getOrgToken()  }
                        };
                        let traderCongnitoSub = null;
                        if(this.isTraderDirectSendToEcn){
                            traderCongnitoSub = authService.getUser().cognitoSub;
                        }
                        if(!this.isTraderDirectSendToEcn){
                            traderCongnitoSub = this.holding[0].traderCognitoSub;
                        }
                        if(this.isOperatorDirectSendToEcn){
                            traderCongnitoSub = null;
                        } 
                        let bidWantedData  = [];
                        const uniqueCusips = [...new Set(this.holding.map(item => item.cusipId))];
                        uniqueCusips.forEach((cusip) => {
                            bidWantedData.push({"id": null,"cusipId": cusip,"bidWantedHoldingDtos":[]})
                        });
                        this.holding.forEach((holding) => {
                            bidWantedData.forEach((data) => {
                                if(data.cusipId == holding.cusipId){
                                    if(!this.isTraderDirectSendToEcn && !this.isOperatorDirectSendToEcn){
                                        data.id = holding.id;
                                        data.bidWantedHoldingDtos.push({traderCustomerId : holding.traderCustomerId,inventoryId : holding.inventoryId,quantity : holding.sellQuantity,spread : holding.spread})
                                    }else{
                                        data.bidWantedHoldingDtos.push({traderCustomerId : holding.traderCustomerId,inventoryId : holding.id,quantity : holding.sellQuantity,spread : holding.spread})
                                    }
                                    // if(this.isOperatorDirectSendToEcn){
                                    //     data.bidWantedHoldingDtos = [];
                                    //     data.id = null;
                                    //     data.bidWantedHoldingDtos.push({inventoryId : holding.id,quantity : holding.sellQuantity,spread : holding.spread})

                                    // }
                                }
                            })
                        })
                        console.log(bidWantedData)
                        let data = {
                            "traderCognitoSub":traderCongnitoSub,
                            "operatorCognitoSub": this.isTraderDirectSendToEcn ? null : authService.getUser().cognitoSub,
                            "status": "NEW",
                            "expireMinutes": this.validTime,
                            "settlementDate": this.moment(this.settlementDate).format("MM/DD/YYYY"),
                            "firmUntilMinutes" : this.firmUntilTime,
                            "bidWanted" : bidWantedData
                            }
                        this.$http
                        .post(config.baseUrlBidSide + "/bidwanted/send-to-ecn",data,auth)
                        .then(() => {
                            this.loading = false;              
                            this.$alert("Successfully sent to ecn","","success");
                            this.$emit('close'); 
                        })
                        .catch(() => {
                            this.loading = false;              
                        });
                    })
            }
            
        },
        getUserSetting(){
            this.loading = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .get(
                config.baseUrlBidSide +
                    "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                    auth
                )
                .then(result => {
                    this.userSettings = result.data;
                    this.userSettings.forEach(element => {
                        if(element.setting == "BW_FIRM_UNTILL_TIME"){
                            this.defaultFirmUntilTime = element.value
                        }
                        if(element.setting == "BW_VALID_UNTILL_TIME"){
                            this.defaultValidUntilTime = element.value
                        }
                        // if(element.setting == "ARBS_SPREAD"){
                        //     this.arbsSpread = element.value
                        // }
                    });
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                });
        },

    },
    mounted(){
        this.getUserSetting();
        this.getOrganizationSetting();
        console.log(this.sendAllResult,this.sendAllPayload)

    }
};
</script>
<style scoped>
.table i {
 color: #E96875 !important; 
}

.count-sec {
    background-color: #2d86bf ;
    border: 1px solid #2d86bf ;
    border-radius: 15px;
    padding: 5px;
    text-transform: uppercase;
    text-align: center;
    font-weight: 900;
}
.count-sec span , .count-sec label {
    color: #fff !important;
}
</style>